module.exports = __webpack_public_path__ + "img/20190612_132334_016.14ec641f.jpg";